// extracted by mini-css-extract-plugin
export var label = "_hg-2";
export var slideContainer = "_hg-0";
export var slider = "_hg-1";